import React, { useState, useEffect } from "react";
import LocationForm from "./LogisticsForm";
import { Column, Row } from "simple-flexbox";
import {
  Paper,
  makeStyles,
  TableBody,
  TableRow,
  TableCell,
  Toolbar,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../../../utilities/useTable";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import Controls from "../../../controls/Controls";
import { Search } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import Popup from "../../../utilities/Popup";
import CloseIcon from "@material-ui/icons/Close";
import Notification from "../../../utilities/Notification";
import ConfirmDialog from "../../../utilities/ConfirmDialog";
import AddLogisticsCost from "./AddLogisticsCost";
import { store } from "../../../../redux-store/store";
import { formatAmount } from "../../../utils/formatPrice";

const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(1),
    padding: theme.spacing(3),
  },
  searchInput: {
    width: "25%",
  },
  newButton: {
    position: "absolute",
    right: "10px",
  },
}));

const headCells = [
  { id: "fromCity", label: "From City" },
  { id: "toCity", label: "To City" },
  { id: "rate", label: "Rate" },
  { id: "effectiveDate", label: "Effective Date" },
  { id: "activeStatus", label: "Active Status" },
  { id: "createdBy", label: "Created By" },
  { id: "endDate", label: "End Date" },
  { id: "actions", label: "Actions", disableSorting: true },
];

export function Logistics({ logisticsCost, states }) {
  const classes = useStyles();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [openPopup, setOpenPopup] = useState(false);
  const [addOpenPopup, setAddOpenPopup] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(logisticsCost, headCells, filterFn);
  useEffect(() => {
    store.dispatch({ type: "LOAD_LOGISTICS_COST" });
    return () => {};
  }, []);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) =>
            x.locationName.toLowerCase().includes(target.value)
          );
      },
    });
  };

  const addSupplier = (location, resetForm) => {
    store.dispatch({ type: "ADD_LOGISTICS_COSTER", payload: location });
    resetForm();
    setRecordForEdit(null);
    setAddOpenPopup(false);
    setOpenPopup(false);
  };

  const openInPopup = (item) => {
    setRecordForEdit(item);
    setOpenPopup(true);
  };

  const onDelete = (id) => {
    store.dispatch({ type: "DELETE_LOGISTIC_COST", payload: id });
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
  };
  return (
    <>
      <div
        className="container"
        style={{ paddingTop: "40px", marginTop: "-5rem" }}
      >
        <div>
          <Column flexGrow={1}>
            <ToastContainer />
            <div className="mt-4 pr-3">
              <Controls.Input
                placeholder="Search Cost by Truck Type/Name"
                className={classes.searchInput}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
                onChange={handleSearch}
              />
            </div>
            <Paper className={classes.pageContent}>
              <h4>
                {" "}
                <strong>Logistics Cost</strong>
              </h4>
              <Toolbar>
                <Controls.Button
                  text="Add Truck Cost"
                  variant="outlined"
                  startIcon={<AddIcon />}
                  className={classes.newButton}
                  onClick={() => {
                    setAddOpenPopup(true);
                    setRecordForEdit(null);
                  }}
                />
              </Toolbar>
              <TblContainer>
                <TblHead />
                <TableBody>
                  {recordsAfterPagingAndSorting().map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{item.fromCity}</TableCell>
                      <TableCell>{item.toCity}</TableCell>
                      <TableCell>{formatAmount(item.rate)}</TableCell>
                      <TableCell>
                        {new Date(item.createdAt).toLocaleDateString()}
                      </TableCell>
                      <TableCell>{item.activeStatus.toString()}</TableCell>
                      <TableCell>
                        {item.createdBy.firstName} {item.createdBy.lastName}
                      </TableCell>
                      <TableCell>
                        {item.endDate == "0001-01-01T00:00:00"
                          ? "N/A"
                          : new Date(item.endDate).toLocaleDateString()}
                      </TableCell>
                      <TableCell>
                        {/* <Controls.ActionButton
                          color="primary"
                          onClick={() => {
                            openInPopup(item);
                          }}
                        >
                          <EditOutlinedIcon fontSize="small" />
                        </Controls.ActionButton> */}
                        <Controls.ActionButton
                          color="secondary"
                          onClick={() => {
                            setConfirmDialog({
                              isOpen: true,
                              title: "Are you sure to delete this record?",
                              subTitle: "You can't undo this operation",
                              onConfirm: () => {
                                onDelete(item.id);
                              },
                            });
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </Controls.ActionButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </Paper>

            <Popup
              title="Add Logistics Cost"
              openPopup={addOpenPopup}
              setOpenPopup={setAddOpenPopup}
            >
              <AddLogisticsCost
                recordForEdit={recordForEdit}
                addLogisticsCost={addSupplier}
              />
            </Popup>

            <Notification notify={notify} setNotify={setNotify} />
            <ConfirmDialog
              confirmDialog={confirmDialog}
              setConfirmDialog={setConfirmDialog}
            />
          </Column>
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    buttonloader: state.utilityReducer.buttonloader,
    user: state.userReducer.user,
    logisticsCost: state.logisticsCostReducer.logisticsCost,
  };
}

const mapDispatchToProps = (dispatch) => ({
  UpdateLocation(payload) {
    dispatch({ type: "UPDATE_LOCATION", payload });
  },

  LoadLogisticsCost(payload) {
    dispatch({ type: "LOAD_LOGISTICS_COST", payload });
  },

  DeleteLogisticsCost(payload) {
    dispatch({ type: "DELETE_LOGISTIC_COST", payload });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Logistics);
